import Request from '~/providers/Request';

const findPartner = async (id) => {
  return await Request.get(`/admin/partner/${id}`).then(resp => {
    if(resp.data){
      resp.data.id = Number(resp.data.id);
      return resp.data;
    }
    return { id: null, name: 'Não localizado' };
  });
};

export default findPartner;
